import React, { FC, useState } from 'react'

import FraIcon from './icons/fra.svg'
import DeIcon from './icons/de.svg'
import EnIcon from './icons/gbr.svg'
import NedIcon from './icons/nld.svg'
import { ITheme } from '@optios-frontend-website/website-public/src/types/theme'
import styled from '../../theme'

const LanguageNav = styled.div`
  height: 42px;
  min-width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 0 0 1px #999;
  cursor: pointer;
  margin: 0 0 0 4px;
  position: relative;
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.link};
  gap: 6px;
  font-weight: 500;
`

const List = styled.ul`
  width: 70px;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.2s linear;

  .language-nav:hover & {
    visibility: visible;
    opacity: 1;
  }
`

const Item = styled.li`
  padding: 0.3em 0.5em;
  font-size: ${({ theme }) => theme.sizes.xsmall};
  font-family: ${({ theme }) => theme.fonts.primary};
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 6px;
  width: 100%;

  &.active {
    background-color: #eeeeee;
    font-weight: 600;
  }

  a {
    display: flex;
    align-items: center;
    width: 100%;
    transition: color 0.2s ease-in-out, border-color 0.2s ease-in-out, opacity 0.2s ease-in-out;
    color: ${(props) => props.theme.colors.link};
    text-decoration: none;
  }
  img {
    margin-right: 0.5em;
  }
  &:hover {
    background-color: #eeeeee;
  }
`

const languages = {
  en: { icon: EnIcon, title: 'English', shortTitle: 'EN' },
  de: { icon: DeIcon, title: 'Deutsch', shortTitle: 'DE' },
  nl: { icon: NedIcon, title: 'Nederlands', shortTitle: 'NL' },
  fr: { icon: FraIcon, title: 'Français', shortTitle: 'FR' },
}

type Props = {
  theme: ITheme
  currentLanguage: string
  languages: string[]
  updateLanguage: (language: string) => void
}

type LanCodes = 'en' | 'de' | 'nl' | 'fr'

const Languages: FC<Props> = (props: Props) => {
  const [current, setCurrent] = useState<LanCodes>(props.currentLanguage as LanCodes)

  return (
    <LanguageNav className="language-nav">
      <img src={languages[current].icon} width={20} />
      <span>{languages[current].shortTitle}</span>

      <List>
        {props.languages.map((language) => (
          <Item
            onClick={(): void => {
              setCurrent(language as LanCodes)
              props.updateLanguage(language)
            }}
            key={language}
            className={current === language ? 'active' : ''}
          >
            <a>
              <img src={languages[language as LanCodes].icon} width={20} />
              <span>{languages[language as LanCodes].shortTitle}</span>
            </a>
          </Item>
        ))}
      </List>
    </LanguageNav>
  )
}

export default Languages
